import React from 'react'
import Media from 'react-media'
import styled from 'styled-components'

import { secondary } from 'styles/colors'

import LargeHeader from './LargeHeader'
import SmallHeader from './SmallHeader'

const Wrapper = styled.header`
  background-color: ${secondary};
`

const Header = props => (
  <Wrapper>
    <Media query="(min-width: 640px)">
      {matches =>
        matches ? <LargeHeader {...props} /> : <SmallHeader {...props} />
      }
    </Media>
  </Wrapper>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js